import React, { useState, useEffect } from "react";
import { Container, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookOpen, faDownload, faFileDownload, faFilePdf, faPrint, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'

import { IPDFPreviewModal } from "../../types/interfaces";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { zoomPlugin, RenderCurrentScaleProps } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

const PDFPreviewModal = ({
  modal,
  setModal,
  handleToggle,
  modalClosedHandle,
  handlePdf,
  data,
  func,
  btnIsDisabled,
  allowPrint,
  previewUrl,
  largeModal,
  // actionAfterPrint
 }: IPDFPreviewModal) => {
  const zoomPluginInstance = zoomPlugin();
  const { CurrentScale, ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

  return <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle} className={`pdfPreview${largeModal ? ` modal-dialog-large` : ""}`}>
      <ModalBody>
        <div className="pdfPreviewContainer">
          <div className="pdfPreviewHeader">
            {allowPrint ? <button className="pdfPreviewButtons pdfPreviewButtonsPrint" disabled={btnIsDisabled} onClick={() => handlePdf(data, func, false, true/*, actionAfterPrint*/)}><FontAwesomeIcon icon={btnIsDisabled ? faSpinner : faPrint} className={btnIsDisabled ? "spinner" : ""} />&nbsp;Imprimer</button> : null}
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <ZoomOutButton />
            <CurrentScale>
              {
                (props: RenderCurrentScaleProps) => <div style={{cursor: "default"}}>{`${Math.round(props.scale * 100)}%`}</div>
              }
            </CurrentScale>
            <ZoomInButton />
            </div>
            {allowPrint ? <button className="pdfPreviewButtons pdfPreviewButtonsDownload" disabled={btnIsDisabled} onClick={() => handlePdf(data, func, true, false/*, actionAfterPrint*/)}><FontAwesomeIcon icon={btnIsDisabled ? faSpinner : faFileDownload} className={btnIsDisabled ? "spinner" : ""} />&nbsp;Télécharger</button> : null}
            <div className="pdfPreviewClose" onClick={handleToggle}><FontAwesomeIcon icon={faTimes} /></div>
          </div>
          <div className="pdfPreviewBody">
            {previewUrl === '' ? '' : <Viewer fileUrl={decodeURIComponent(previewUrl)} plugins={[zoomPluginInstance]} />}
          </div>
        </div>
      </ModalBody>
    </Modal>
};

export default PDFPreviewModal;